import { MemreToggleButtonGroup } from 'components/core';

export default function MultiResponseToggle({ value, onChange }) {
  const options = [
    { value: 'multi_correct', label: 'Multiple Select Response' },
    { value: 'single_correct', label: 'Single Select Response' },
  ];

  return <MemreToggleButtonGroup options={options} value={value} onChange={onChange} />;
}
